export const REQUEST_TIMEOUT_MILLISECONDS = 15000;
export const GITLAB_API_BASE_URL = 'https://gitlab.com';
export const SUGGESTION_ACCEPTED_COMMAND = 'gitlab.ls.codeSuggestionAccepted';
export const START_STREAMING_COMMAND = 'gitlab.ls.startStreaming';
export const WORKFLOW_DEFAULT_EXECUTOR_VERSION = 'v0.0.7';
export const SUGGESTIONS_DEBOUNCE_INTERVAL_MS = 250;
export const WORKFLOW_DEFAULT_EXECUTOR_DOWNLOAD_PATH = `https://gitlab.com/api/v4/projects/58711783/packages/generic/duo-workflow-executor/${WORKFLOW_DEFAULT_EXECUTOR_VERSION}/duo-workflow-executor.tar.gz`;
